import ButtonIcon from "components/ButtonIcon"
import { TourOrderWrapper } from "./styled"
import { FaEye } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import TableComponent from "components/Table";
import { tourOrderSelector } from 'redux/selector'
import { tourOrderActions } from 'redux/slice/tourOrder'
import FormSearch from "components/FormSearch";
import useDebounce from 'hooks/useDebounce'
import StatusLabel from "components/StatusLabel";
import { get_day_of_time, setPrice } from "utils";
import Modal from "./Modal";
import Loading from "components/Loading";

const TourOrder = () => {
    document.title = 'Quản lý đặt tour'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const tourOrderState = useSelector(tourOrderSelector)
    const dispatch = useDispatch()
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const [status, setStatus] = useState('')
    const [queryInput, setQueryInput] = useState('')
    const querySearch = useDebounce(queryInput, 500)

    useEffect(() => {
        dispatch(tourOrderActions.getTourAdmin({ status, query: querySearch, currentPage }))
    }, [currentPage, dispatch, querySearch, status])
    const callback = () => {
        dispatch(tourOrderActions.getTourAdmin({ status, query: querySearch, currentPage }))
    }
    const handleChangeStatus = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/order?page=1`)
        }
        setStatus(e.target.value)
    }
    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/order?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/order?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }


    const handleShowDetailModal = (selectedId) => {
        setSelectedId(selectedId)
        setShowModal(!showModal)
    }


    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            align: "center"
        },
        {
            title: 'Tour',
            dataIndex: 'name',
            key: 'name',
            align: "center"
        },
        {
            title: 'Khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            align: "center"
        },
        {
            title: 'Điện thoại',
            dataIndex: 'customer_phone',
            key: 'customer_phone',
            align: "center"
        },
        {
            title: 'Ngày khởi hành',
            dataIndex: 'departure_day',
            key: 'departure_day',
            align: "center"
        },
        {
            title: 'Số người',
            dataIndex: 'amount_of_people',
            key: 'amount_of_people',
            align: "center"
        },
        {
            title: 'Đơn giá / người',
            key: 'price',
            align: "center",
            render: ({ price }) => (
                <span>{setPrice(price)}</span>
            )
        },
        {
            title: 'Giảm giá',
            dataIndex: 'discount',
            key: 'discount',
            align: "center"
        },
        {
            title: 'Tổng tiền',
            align: "center",
            render: ({ price, amount_of_people, discount }) => (
                <span>{setPrice(price * amount_of_people - price * amount_of_people / 100 * discount)}</span>
            )
        },
        {
            title: 'Phụ trách',
            dataIndex: 'staff_name',
            key: 'staff_name',
            align: "center"
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (_, { departure_day, status }) => (
                <>

                    {
                        (status > 0 || (parseInt(get_day_of_time(new Date(), new Date(departure_day))) >= 0)) &&
                        < StatusLabel
                            status={status}
                        />
                    }
                    {
                        parseInt(get_day_of_time(new Date(), new Date(departure_day))) < 0 && status === 0 &&
                        <span className="end_time no-wrap">Hết hạn</span>
                    }
                </>

            )
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { id, tour_status }) => (
                <>
                    {
                        tour_status === 0 &&
                        <ButtonIcon
                            onClick={() => handleShowDetailModal(id)}
                            icon={<FaEye />}
                            description='Chi tiết'
                            classButton="action-primary btn-action"
                        />
                    }
                    {
                        tour_status === 1 &&
                        <span className="label_tour_1 no-wrap">Tạm dừng</span>
                    }
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + tourOrderState.tourOrderAdmin.length)
        }
        else {
            setTotalItemInPage(tourOrderState.tourOrderAdmin.length)
        }
    }, [currentPage, tourOrderState.tourOrderAdmin.length])
    return (
        <TourOrderWrapper>
            <div className="admin_order_control py-0 px-15">
                <div className="admin_order_control py-0 px-15">
                    <FormSearch
                        placeholder='Tìm kiếm tour order...'
                        queryInput={queryInput}
                        onChange={handleChangeSearchInput}
                        setQueryInput={setQueryInput}
                    />

                </div>
                <div className="admin_order_control_sort-add">
                    <div className="admin_order_control_sort-add">
                        <select className="mr-15 px-10" onChange={handleChangeStatus}>
                            <option value=''>Toàn bộ</option>
                            <option value='0'>Chờ xác nhận</option>
                            <option value='1'>Đang thực hiện</option>
                            <option value='2'>Hoàn thành</option>
                            <option value='3'>Đã hủy</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="admin_order_table">

                {
                    tourOrderState.loading &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={tourOrderState.tourOrderAdmin}
                />
            </div>
            {
                tourOrderState.tourOrderAdmin.length > 0 &&
                <div className="admin_order_pagination mt-15 px-15">
                    <span className="admin_order_pagination_total_item medium">
                        {totalItemInPage} / {tourOrderState.totalItem}
                    </span>
                    {
                        tourOrderState.totalPage > 1 &&
                        <Pagination count={tourOrderState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
            <Modal
                selectedId={selectedId}
                showModal={showModal}
                hidden={handleHiddenForm}
                callback={callback}
            />
        </TourOrderWrapper>
    )
}

export default TourOrder